export default {
    namespaced: true,
    state: {
        userInfo: {},
        customerOptions: [], // 派单员
        orderOptions: [], //客服
        repairTypeOptions: [{
                label: '维修',
                id: "维修"
            },

            {
                label: '开机',
                id: "开机"
            },

            {
                label: '巡检',
                id: "巡检"
            },

            {
                label: '其他',
                id: "其他"
            }
        ],
        serviceStatus: [{
                label: '待处理',
                id: "待处理"
            },

            {
                label: '待分配',
                id: "待分配"
            },

            {
                label: '处理中',
                id: "处理中"
            }
        ],
        priorityList: [{
                label: "标准",
                id: 0
            },

            {
                label: "紧急",
                id: 1
            },


        ],
        enginerList: [],
        serviceStatusList: [],
        serviceType: [ // 服务类别
            {
                label: '维修',
                id: 0
            },

            {
                label: '开机',
                id: 1
            },
            {
                label: '开机转维修',
                id: 2
            },
            {
                label: '巡检',
                id: 3
            },
            {
                label: '其他',
                id: 4
            },

        ],
        cityList: [{
                label: '北京',
                id: '北京'
            },
            {
                label: '天津',
                id: '天津'
            },
            {
                label: '河北',
                id: '河北'
            },
            {
                label: '山西',
                id: '山西'
            },
            {
                label: '内蒙古',
                id: '内蒙古'
            },
            {
                label: '辽宁',
                id: '辽宁'
            },
            {
                label: '吉林',
                id: '吉林'
            },
            {
                label: '黑龙江',
                id: '黑龙江'
            },
            {
                label: '上海',
                id: '上海'
            },
            {
                label: '江苏',
                id: '江苏'
            },
            {
                label: '浙江',
                id: '浙江'
            },
            {
                label: '安徽',
                id: '安徽'
            }, {
                label: '福建',
                id: '福建'
            },
            {
                label: '江西',
                id: '江西'
            },
            {
                label: '山东',
                id: '山东'
            },
            {
                label: '河南',
                id: '河南'
            },
            {
                label: '湖北',
                id: '湖北'
            },
            {
                label: '湖南',
                id: '湖南'
            },
            {
                label: '广东',
                id: '广东'
            },
            {
                label: '广西',
                id: '广西'
            },
            {
                label: '海南',
                id: '海南'
            },
            {
                label: '重庆',
                id: '重庆'
            },
            {
                label: '四川',
                id: '四川'
            }, {
                label: '贵州',
                id: '贵州'
            },
            {
                label: '云南',
                id: '云南'
            },
            {
                label: '西藏',
                id: '西藏'
            },
            {
                label: '陕西',
                id: '陕西'
            },
            {
                label: '甘肃',
                id: '甘肃'
            },
            {
                label: '青海',
                id: '青海'
            },
            {
                label: '宁夏',
                id: '宁夏'
            },
            {
                label: '新疆',
                id: '新疆'
            },
            {
                label: '台湾',
                id: '台湾'
            },
            {
                label: '香港',
                id: '香港'
            },
            {
                label: '澳门',
                id: '澳门'
            }


        ],
        partsList: [],
        province: "",
        areaList: []

    },
    getters: {
        changeServiceType(state) {
            let arr = [];
            let serviceType = state.serviceType
            arr.push(serviceType[0])
            arr.push(serviceType[3])
            return arr
        }
    },
    mutations: {
        setUserInfo(state, userInfo) {
            state.userInfo = userInfo;
        },
        setAreaList(state, areaList) {
            state.areaList = areaList;
        },
        setpartsList(state, partsList) {
            state.partsList = partsList;
        },
        setEnginerList(state, enginerList) {
            state.enginerList = enginerList;
        },
        setServiceStatus(state, serviceStatusList) {
            state.serviceStatusList = serviceStatusList;
        },
        setOrderOptions(state, orderOptions) {
            state.orderOptions = orderOptions;
        },
        setCustomerOptions(state, customerOptions) {
            state.customerOptions = customerOptions;
        },
        resetInput(state, className) {
            console.log(className)
            let inputs = document.getElementsByClassName(className)[0].getElementsByTagName('input');
            for (let i = 0; i < inputs.length; i++) {
                inputs[i].value = ""
            }
        }
    }
}
{/* <el-dialog title="批量导入单" :visible.sync="fileDialog">
      <el-upload
        class="upload-demo"
        :drag="true"
        :multiple="false"
        action="#"
        :show-file-list="false"
        :limit="3"
        :file-list="fileList"
        :http-request="fileUpload"
        :before-upload="beforeUploadFile"
        accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel,.csv"
      >
        <i class="el-icon-upload"></i>
        <div class="el-upload__text">
          <em>点击上传</em>
        </div>
      </el-upload>
    </el-dialog> */}